export function getVSSMatchSide(match, team, side = "home") {
  if (!team) return side;
  const home = match.teamA?.Name === team;
  const away = match.teamB?.Name === team;
  if (!home && !away) throw new Error(`Cannot identify "${team}" in every selected match.`);
  if (home && away) return side;
  return home === (side === "home") ? "home" : "away";
}

function flipTeam(team) {
  if (team === "*") return "a";
  if (team === "a") return "*";
  if (team === "A") return "B";
  if (team === "B") return "A";
  return team;
}

function swapSides(sides) {
  if (!sides) return sides;
  return { home: sides.away, away: sides.home };
}

function flipVsmScoutEvent(event) {
  const flipped = { ...event, lineup: swapSides(event.lineup) };
  if (event.substitution) {
    flipped.substitution = {
      ...event.substitution,
      team: flipTeam(event.substitution.team),
    };
  }
  if (event.exchange) {
    flipped.exchange = {
      ...event.exchange,
      point: flipTeam(event.exchange.point),
      plays: (event.exchange.plays ?? []).map((play) => ({
        ...play,
        team: flipTeam(play.team),
      })),
    };
  }
  if (event.score) {
    flipped.score = { home: event.score.away, away: event.score.home };
  }
  return flipped;
}

export function orientVsmForHomeTeam(vsm, side = "home") {
  if (side !== "away") return vsm;
  return {
    ...vsm,
    team: { ...vsm.team, home: vsm.team.away, away: vsm.team.home },
    scout: {
      ...vsm.scout,
      sets: (vsm.scout?.sets ?? []).map((set) => ({
        ...set,
        startingLineup: swapSides(set.startingLineup),
        events: (set.events ?? []).map(flipVsmScoutEvent),
        score: set.score
          ? { home: set.score.away, away: set.score.home }
          : set.score,
      })),
    },
  };
}
